/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IError } from '../../../../../base/api';
import { Area, City, Country } from '../../../../../base/interfaces/config';
import { SetFieldParams } from '../../../../../base/interfaces/params';
import { RecruiterType } from '../../../../enums';

export interface Fields {
    id: number | null;
    image: File | null;
    name: string;
    cityId: number | null;
    phone: string;
    type: RecruiterType;
    agencyName: string;
    website: string | null;
    description: string | null;
    areas: Area[];
    countries: Country[];
    imageUrl: string | null;
    city: City | null;
}

export interface ProfileState {
    fields: Fields;
    errors: IError | null;
    shouldScrollToError: boolean;
}

const fieldsInitialState: Fields = {
    id: null,
    name: '',
    cityId: null,
    phone: '',
    type: RecruiterType.Agency,
    agencyName: '',
    website: null,
    description: null,
    areas: [],
    countries: [],
    image: null,
    imageUrl: null,
    city: null,
};

const initialState: ProfileState = {
    fields: fieldsInitialState,
    errors: null,
    shouldScrollToError: false,
};

export const profileSlice = createSlice({
    name: 'recruiter-app__profile',
    initialState,
    reducers: {
        getProfileData: () => {},
        setProfileData: (state, action: PayloadAction<Fields>) => {
            state.fields = action.payload;
        },
        clearData: (state) => {
            state.fields = fieldsInitialState;
            state.errors = null;
            state.shouldScrollToError = false;
        },
        setField: (state, action: PayloadAction<SetFieldParams>) => {
            state.fields = {
                ...state.fields,
                [action.payload.id]: action.payload.value,
            };
            if (state.errors === null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload.errorGroupName || action.payload.id]: removedError, ...errors } = state.errors;
            state.errors = errors;
        },
        setErrors: (state, action: PayloadAction<IError>) => {
            if (state.errors) {
                state.errors = {
                    ...state.errors,
                    ...action.payload,
                };
            } else {
                state.errors = action.payload;
            }
        },
        setShouldScrollToError: (state, action: PayloadAction<boolean>) => {
            state.shouldScrollToError = action.payload;
        },
        submitProfile: {
            reducer: () => {},
            prepare: (callback?: () => void) => ({ payload: callback }),
        },
        uploadLogo: {
            reducer: () => {},
            prepare: (logo: File) => ({ payload: logo }),
        },
    },
});

export const profileActions = profileSlice.actions;
export const profileReducer = profileSlice.reducer;
